export default "__VITE_ASSET__25106425__"